module.exports = __webpack_public_path__ + "static/media/IRWIN-quarantine-dashboard.4d93845b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/IRWIN-quarantine-dashboard.png
// module id = 2672
// module chunks = 0